import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import { useLocalization } from '../../providers/LocaleProvider';
import type { SpaceProps } from '../../theme/system-types';
import { Flex } from '../Flex';
import type { LoadButtonProps } from './LoadButton';
import LoadButton from './LoadButton';
import type { ProductsShownInfoProps } from './ProductsShownInfo';
import ProductsShownInfo from './ProductsShownInfo';

export type LoadMoreButtonProps = LoadButtonProps & ProductsShownInfoProps;

const LoadMoreButtonWrapper = styled(Flex)<any>`
  ${space};
`;

const buttonWrapperStyles: ComponentProps<typeof LoadMoreButtonWrapper> = {
  flexDirection: 'column',
  alignItems: 'center',
  my: ['sp_16', 'sp_20', 'sp_24', 'sp_32'],
};

const StyledProductsShownInfo = styled(ProductsShownInfo)<SpaceProps>`
  ${space};
`;

const roundedButtonStyles: SpaceProps = {
  mb: ['sp_8', null, 'sp_16'],
};

const LoadMoreButton = ({ count, totalCount, my, isRounded, ...props }: LoadMoreButtonProps) => {
  const { t, r } = useLocalization();

  return (
    <LoadMoreButtonWrapper {...buttonWrapperStyles} {...(my ? { my } : {})}>
      <StyledProductsShownInfo
        {...(isRounded ? roundedButtonStyles : {})}
        count={count}
        totalCount={totalCount}
      />
      <LoadButton
        {...props}
        isRounded={isRounded}
        ariaLabel={r.t('h24_load_more_products', { count, totalCount })}
      >
        {t('h24_load_more')}
      </LoadButton>
    </LoadMoreButtonWrapper>
  );
};

export default LoadMoreButton;
